import { AbstractClone } from "../../abstract/clone.abstract";
import { Injectable, Injector } from "@angular/core";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";
import { CloneService } from "./clone.service";
import { WidgetsSectionModel } from "src/app/models/widgets/widgets-section.model";
import { WidgetsFormModel } from "src/app/models/widgets/widgets-form.model";
import { WidgetsContainerAbstract } from "src/app/abstract/widgets/widgets-container.abstract";
import { WidgetsRowModel } from "src/app/models/widgets/widgets-row.model";

@Injectable({
  providedIn: 'root'
})
export class CloneRowService extends AbstractClone {

  constructor(private injector: Injector) {
    super();
  }

  cloneFromJS(origWidget: any,
    destWidget: WidgetsAbstract,
    isDragNDrop: boolean,
    isInsideQuestion: boolean,
    parentId: string | undefined) {

    // Retrieve from injector to avoid circular dependency
    const widgetsCloneService = this.injector.get(CloneService);

    // Cloning from JSON to TypeScript
    const origRow = origWidget as WidgetsRowModel;    
    const newRow = new WidgetsRowModel();
    newRow.parentId = parentId;
    newRow.template = origWidget.template;
    const parentContainer = destWidget as WidgetsContainerAbstract;    
    parentContainer.children.push(newRow);    
    origRow.children.forEach(childWidget => {
      widgetsCloneService.cloneFromJS(childWidget, newRow, isDragNDrop, isInsideQuestion, newRow.id);
    });
  }
}
